export const hasRole = (roles, roleName) => {
  return roles.some(role => role === roleName);
};

export const rolePermissions = {
  hasAdmin: (roles) => hasRole(roles, "admin"),
  hasHoStaff: (roles) => hasRole(roles, "HO Staff"),
  hasSupplier: (roles) => hasRole(roles, "supplier"),
  hasManager: (roles) => hasRole(roles, "warehouse_manager"),
  hasProvider: (roles) => hasRole(roles, "loan_provider"),
  hasMaker: (roles) => roles.some((role) => role?.toUpperCase() === "MAKER"),
  hasChecker: (roles) => roles.some((role) => role?.toUpperCase() === "CHECKER"),

};